

const EntryService = require('../services/EntryService').default;
const getSpace = require('./contentful/get-space');
const transformer = require('./transformers/entity');
const processError = require('./contentful/error-process');
const linkResolve = require('./contentful/link-resolve');

let entryService = null;

const gettingEntryService = () => {
  if (!entryService) {
    entryService = getSpace().then((space) => {
      return new EntryService(space, transformer);
    });
  }

  return entryService;
};

module.exports = {
  getById(...parameters) {
    return gettingEntryService().then((service) => service.getById(...parameters));
  },

  search(config) {
    config = Object.assign({
      query: '',
      limit: 10,
      offset: 0,
      contentType: null,
      options: {},
      filterFn: null
    }, config || {});
    return getSpace().then((space) => {
      const options = Object.assign({}, config.options, {
        query: config.query,
        skip: config.offset,
        limit: config.limit,
        order: '-sys.updatedAt'
      });

      if (!config.showArchived) {
        options['sys.archivedAt[exists]'] = false;
      }

      // Hello, Contentful. Why the /&5%&")" can we only filter search by ONE contenttype? Huh? WHYYYYYYY??
      if (config.contentType) {
        options.content_type = config.contentType;
      }

      return space.getEntries(
        options
      ).catch(
        processError
      ).then((entries) => {
        if (config.filterFn) {
          entries.items = entries.items.filter(config.filterFn);
        }

        const items = linkResolve(space, entries.items, 1).then((items) => {
          return items;
        });
        return Promise.all([entries, items]);
      }).then((result) => {
        const entries = result[0];
        const items = result[1];
        return {
          items: items.map(transformer.contentfulToInternal),
          limit: entries.limit,
          offset: entries.skip,
          total: entries.total
        };
      });
    });
  }
};
